import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface HasValidOtcResponse extends BackendResponse {
  /** True when an unconsumed, unexpired, under-attempt-cap code is already on
   *  file for this email — so the client can skip the "send code" intro step. */
  hasValid: boolean;
}

export interface HasValidOtcParameters extends NextApiParams {
  email: string;
}

export const hasValidOtc = withNextApi<
  HasValidOtcResponse,
  HasValidOtcParameters
>("/auth/HasValidOtc", {
  method: "GET",
});
